var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.073C28 9.40577 22.6269 4 16 4C9.37308 4 4 9.40577 4 16.073C4 22.0985 8.38757 27.0934 14.1252 28V19.5637H11.0775V16.073H14.1252V13.4126C14.1252 10.3871 15.9173 8.71477 18.6579 8.71477C19.9707 8.71477 21.3444 8.95076 21.3444 8.95076V11.9219H19.8307C18.3406 11.9219 17.8748 12.8523 17.8748 13.8081V16.073H21.2026L20.6711 19.5637H17.8748V28C23.6124 27.0951 28 22.1002 28 16.073Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d3d6f84c.svg";
export { ForwardRef as ReactComponent };